// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sWUa","badges":"styles_badges__13abN"};